import React from "react";
import { connect } from "react-redux";
import { actions as routerActions } from "redux-router5";

import * as Routes from "../routing/routes";
import LayoutWithFooter from "../page/layout-with-footer";
import AppSecondaryBackground from "../root/app-secondary-background";
import PageHeader from "../page/page-header";
import Consent from "../general-info/consent";
import userActions from "../user/user-actions";
import { getBrand } from "../brand/brand-selectors";

function ConsentPage({ goTo, setConsent, brand }) {
  return (
    <AppSecondaryBackground>
      <LayoutWithFooter className="Consent ConsentPage">
        <PageHeader className={"ConsentPage__Header"} logo={brand.imagePost} />
        <Consent
          onNext={() => {
            goTo(Routes.SIGN_UP);
            setConsent(true);
          }}
        />
      </LayoutWithFooter>
    </AppSecondaryBackground>
  );
}

const mapState = state => ({
  brand: getBrand(state)
});
const mapDispatch = {
  goTo: routerActions.navigateTo,
  setConsent: userActions.Creators.setConsent
};

ConsentPage = connect(
  mapState,
  mapDispatch
)(ConsentPage);

export default ConsentPage;



// WEBPACK FOOTER //
// ./src/modules/pages/ConsentPage.js